import React, { useState, useEffect } from 'react';
import { AppProvider, useApp } from './context/AppContext';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import NotificationsPanel from './components/NotificationsPanel';
import Modal from './components/Modal';
import ToastContainer from './components/Toast';
import Login from './pages/auth/Login';
import ForcePasswordChange from './pages/auth/ForcePasswordChange';
import OTP from './pages/auth/OTP';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import Dashboard from './pages/Dashboard';
import Contacts from './pages/Contacts';
import Deals from './pages/Deals';
import Pipeline from './pages/Pipeline';
import Tasks from './pages/Tasks';
import Workflows from './pages/Workflows';
import Players from './pages/Players';
import PlayerOnboarding from './pages/PlayerOnboarding';
import PlayerRequests from './pages/PlayerRequests';
import SelfieVerification from './pages/SelfieVerification';
import Scouts from './pages/Scouts';
import Clubs from './pages/Clubs';
import Organizers from './pages/Organizers';
import CommunityCreation from './pages/CommunityCreation';
import CommunityGroups from './pages/CommunityGroups';
import MobileMarketplace from './pages/MobileMarketplace';
import Payments from './pages/Payments';
import Payouts from './pages/Payouts';
import Agents from './pages/Agents';
import Events from './pages/Events';
import TrialApplications from './pages/TrialApplications';
import AuditTrail from './pages/AuditTrail';
import UserManagement from './pages/UserManagement';
import MatchRatings from './pages/MatchRatings';
import CommunityMatches from './pages/CommunityMatches';
import PitchCreation from './pages/PitchCreation';
import Pitches from './pages/Pitches';
import PitchRequests from './pages/PitchRequests';
import Notifications from './pages/Notifications';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import HelpSupport from './pages/HelpSupport';
import Developer from './pages/Developer';
import Membership from './pages/Membership';
import MarketingEmails from './pages/MarketingEmails';
import Sequences from './pages/Sequences';
import Lists from './pages/Lists';
import Reports from './pages/Reports';
import Meetings from './pages/Meetings';
import Forms from './pages/Forms';
import LandingPages from './pages/LandingPages';
import SocialMedia from './pages/SocialMedia';
import Ads from './pages/Ads';
import SMS from './pages/SMS';
import Blog from './pages/Blog';
import CTAs from './pages/CTAs';
import Tickets from './pages/Tickets';
import KnowledgeBase from './pages/KnowledgeBase';
import Surveys from './pages/Surveys';
import LiveChat from './pages/LiveChat';
import SalesForecast from './pages/SalesForecast';
import Quotes from './pages/Quotes';
import Documents from './pages/Documents';
import Products from './pages/Products';
import CallLog from './pages/CallLog';
import CustomProperties from './pages/CustomProperties';
import Inbox from './pages/Inbox';
import Playbooks from './pages/Playbooks';
import Goals from './pages/Goals';
import ActivityDashboard from './pages/ActivityDashboard';
import Integrations from './pages/Integrations';
import Permissions from './pages/Permissions';
import NotFound from './pages/NotFound';
import './App.css';

const PAGES = {
  dashboard:            { label:'Dashboard',           component:Dashboard },
  players:              { label:'Players',             component:Players },
  'player-onboarding':  { label:'Player Onboarding',   component:PlayerOnboarding },
  'player-requests':    { label:'Player Requests',     component:PlayerRequests },
  selfieVerification:   { label:'Selfie Verification',  component:SelfieVerification },
  scouts:               { label:'Scouts',              component:Scouts },
  agents:               { label:'Agents',              component:Agents },
  clubs:                { label:'Clubs',               component:Clubs },
  organizers:           { label:'Organizers',          component:Organizers },
  'community-groups':   { label:'Groups',              component:CommunityGroups },
  'community-creation': { label:'Create Group',        component:CommunityCreation },
  'mobile-marketplace':  { label:'Mobile Marketplace',  component:MobileMarketplace },
  events:               { label:'Events',              component:Events },
  payments:             { label:'Payments',            component:Payments },
  payouts:              { label:'Payouts',              component:Payouts },
  'trial-applications': { label:'Trial Applications',  component:TrialApplications },
  'audit-trail':        { label:'Audit Trail',         component:AuditTrail },
  'user-management':    { label:'User Management',     component:UserManagement },
  'match-ratings':      { label:'Match Ratings',        component:MatchRatings },
  'community-matches':   { label:'Community Matches',    component:CommunityMatches },
  'pitch-creation':      { label:'Create Pitch',         component:PitchCreation },
  'pitches':             { label:'Pitch Marketplace',    component:Pitches },
  'pitch-requests':      { label:'Pitch Requests',        component:PitchRequests },
  'notifications':       { label:'Notifications',          component:Notifications },
  contacts:             { label:'Contacts',            component:Contacts },
  deals:                { label:'Deals',               component:Deals },
  pipeline:             { label:'Pipeline',            component:Pipeline },
  tasks:                { label:'Tasks',               component:Tasks },
  workflows:            { label:'Workflows',           component:Workflows },
  meetings:             { label:'Meetings',            component:Meetings },
  'call-log':           { label:'Call Log',            component:CallLog },
  'sales-forecast':     { label:'Sales Forecast',      component:SalesForecast },
  quotes:               { label:'Quotes',              component:Quotes },
  documents:            { label:'Documents',           component:Documents },
  products:             { label:'Products',            component:Products },
  playbooks:            { label:'Playbooks',           component:Playbooks },
  'marketing-emails':   { label:'Marketing Emails',    component:MarketingEmails },
  sequences:            { label:'Sequences',           component:Sequences },
  lists:                { label:'Lists',               component:Lists },
  forms:                { label:'Forms',               component:Forms },
  'landing-pages':      { label:'Landing Pages',       component:LandingPages },
  'social-media':       { label:'Social Media',        component:SocialMedia },
  ads:                  { label:'Ads',                 component:Ads },
  sms:                  { label:'SMS',                 component:SMS },
  blog:                 { label:'Blog',                component:Blog },
  ctas:                 { label:'CTAs',                component:CTAs },
  reports:              { label:'Reports',             component:Reports },
  tickets:              { label:'Tickets',             component:Tickets },
  'knowledge-base':     { label:'Knowledge Base',      component:KnowledgeBase },
  surveys:              { label:'Surveys',             component:Surveys },
  'live-chat':          { label:'Live Chat',           component:LiveChat },
  inbox:                { label:'Inbox',               component:Inbox },
  goals:                { label:'Goals',               component:Goals },
  'activity-dashboard': { label:'Activity Dashboard',  component:ActivityDashboard },
  integrations:         { label:'Integrations',        component:Integrations },
  permissions:          { label:'Permissions',         component:Permissions },
  'custom-properties':  { label:'Custom Properties',   component:CustomProperties },
  developer:            { label:'Developer',           component:Developer },
  membership:           { label:'Membership',          component:Membership },
  profile:              { label:'Profile',             component:Profile },
  settings:             { label:'Settings',            component:Settings },
  help:                 { label:'Help & Support',      component:HelpSupport },
};

const AUTH_FLOWS = { login:Login, otp:OTP, forgot:ForgotPassword, reset:ResetPassword };

function CRMShell() {
  const { auth, login, logout, modal, openModal, closeModal, toast, page, navigate } = useApp();
  const [authStep, setAuthStep]       = useState('login');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notifOpen, setNotifOpen]     = useState(false);

  useEffect(() => {
    const handler = (e) => { navigate(e.detail); setNotifOpen(false); };
    window.addEventListener('crm-navigate', handler);
    return () => window.removeEventListener('crm-navigate', handler);
  }, [navigate]);

  if (auth && auth.mustChangePassword) {
    return <ForcePasswordChange />;
  }

  if (!auth) {
    const AuthComponent = AUTH_FLOWS[authStep] || Login;
    return (
      <AuthComponent
        onLogin={(creds) => login(creds)}
        onOTP={() => setAuthStep('otp')}
        onForgot={() => setAuthStep('forgot')}
        onReset={() => setAuthStep('reset')}
        onBack={() => setAuthStep('login')}
      />
    );
  }

  const cfg = PAGES[page] || { label:'404', component:NotFound };
  const PageComponent = cfg.component;

  return (
    <div className="app-shell">
      <Sidebar current={page} onChange={p => { navigate(p); setSidebarOpen(false); }} mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} auth={auth} />
      <div className="app-main">
        <Header
          title={cfg.label}
          onMenuToggle={() => setSidebarOpen(o=>!o)}
          onNotif={() => setNotifOpen(o=>!o)}
          notifOpen={notifOpen}
          user={auth}
          onLogout={logout}
          onNavigate={navigate}
        />
        <main className="app-content">
          <PageComponent openModal={openModal} toast={toast} onChange={navigate} />
        </main>
      </div>
      {notifOpen && <NotificationsPanel onClose={() => setNotifOpen(false)} />}
      {modal && <Modal modal={modal} onClose={closeModal} />}
      <ToastContainer />
    </div>
  );
}

export default function App() {
  return <AppProvider><CRMShell /></AppProvider>;
}
